import * as React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt, faPaperclip, faFileImage } from '@fortawesome/free-solid-svg-icons';
import { Label, Button } from 'reactstrap';

const inputUploadFile: React.CSSProperties = {
    display: 'none',
};

const buttonUploadFile: React.CSSProperties = {
    margin: 8,
};

interface UploaderProps {
    openPreview?: any;
    translate?: any;
    customRequest?: any;
    customRemove?: any;
    onTheRight?: boolean;
}
interface UploaderState {
    Files: CustomFile[];
}
interface CustomFile extends File {
    Id: number;
    Status: string;
}
export class Uploader extends React.Component<UploaderProps, UploaderState>  {
    state = {
        Files: [] as CustomFile[]
    }
    getFileFromInput(file: File): Promise<any> {
        return new Promise(function (resolve, reject) {
            const reader = new FileReader();
            reader.onerror = reject;
            reader.onload = function () { resolve(reader.result); };
            reader.readAsBinaryString(file); // here the file can be read in different way Text, DataUrl, ArrayBuffer
        });
    }

    handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        event.persist();
        let reader: any = new FileReader();
        if (event.target.files) {
            let file: any = event.target.files[0];
           /* console.log('test', file)*/
            reader.onloadend = () => {
                let Files = this.state.Files;

                file.Id = Date.now();
                file.Data = reader.result;
                file.Status = 'success';
                let customFile = file;
                Files.push(customFile);
                this.setState({ Files });

                this.props.customRequest(file, this.onSuccess, this.onFailure);


            }
            try {
                reader.readAsDataURL(file)

            } catch (error) {
                console.error('_UploadImage', error)
            }
            //Array.from(event.target.files).forEach(file => {                
            //});

        }
        event.target.value = ''
    }
    onSuccess = (file: any) => {
        let Files = this.state.Files;
        Files.filter((item: any) => item.Id === file.Id)[0].Status = 'success';
        this.setState({ Files });
    }
    onFailure = (file: any) => {
        let Files = this.state.Files;
        Files.filter((item: any) => item.Id === file.Id)[0].Status = 'failure';
        this.setState({ Files });
    }
    removeFile = (Id: number) => {
        this.props.customRemove(this.state.Files.filter((item: CustomFile) => item.Id === Id)[0]);
        let Files = this.state.Files.filter((item: CustomFile) => item.Id !== Id);
        this.setState({ Files });
    }
    inputRef: any = React.createRef();
    buttonOnClick = (e: any) => {
        this.inputRef.current.click();
    }
    render() {
        return (
            <div className={this.props.onTheRight ? "" : "d-flex"}>
                {!this.props.onTheRight &&
                    <div className="mt-2">
                        {this.state.Files.map((file: any) =>
                            <div key={'file_' + file.Id} className={"backgroundGrey p-2 fitcontent mb-2 "}>
                                <FontAwesomeIcon icon={faFileImage} className="mr-2 d-inline-flex iconGrey" />
                                <Label className="d-inline-flex LabelCreate2 mr-3 ml-3"  > {file.name} </Label>
                                <FontAwesomeIcon icon={faTrashAlt} className="ml-3 iconGrey cursor-pointer" onClick={() => { this.removeFile(file.Id); }} />
                            </div>
                        )}
                    </div>
                }
                <div className={this.props.onTheRight ? "mr-auto pt-2" : "ml-auto"}>
                    <input ref={this.inputRef} accept="image/*,.pdf,.doc,.docx,.xls,.xlsx" style={inputUploadFile} id="file" multiple={false} type="file"
                        onChange={this.handleFileChange} />
                    <label htmlFor="file">
                        <Button className={this.props.onTheRight ? "EmptyBtn m-0 mt-2" : "EmptyBtn"} style={buttonUploadFile} onClick={this.buttonOnClick}>
                            <FontAwesomeIcon icon={faPaperclip} className="mr-2" /> {this.props.translate('Attach')}
                        </Button>
                    </label>
                </div>
                {this.props.onTheRight &&
                    <div className=" d-flex align-content-around flex-wrap">
                        {this.state.Files.map((file: any) =>
                            <div key={'file_' + file.Id} className={"backgroundGrey p-2 fitcontent mb-2 mr-2 "}>
                                <FontAwesomeIcon icon={faFileImage} className="mr-2 d-inline-flex iconGrey" />
                                <Label className="d-inline-flex LabelCreate2 mr-3 ml-3"  > {file.name} </Label>
                                <FontAwesomeIcon icon={faTrashAlt} className="ml-3 iconGrey cursor-pointer" onClick={() => { this.removeFile(file.Id); }} />
                            </div>
                        )}
                    </div>
                }
            </div>
        );
    }
}
